/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_State_In_ProgressInputs */



/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Table_State_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const table_state_in_progress = /** @type {((inputs?: Table_State_In_ProgressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_State_In_ProgressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("En progreso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("In corso")
	return /** @type {LocalizedString} */ ("In Progress")
});